
import QuestionDialogComponent from '@/components/dialogs/QuestionDialog.vue'
import { situacaoPedidoMap } from '@/components/utils'
import MemoryDataTable from '@/components/wmc/MemoryDataTable.vue'
import PedidoInterface from '@/interfaces/Pedido'
import PedidoService from '@/services/PedidoService'
import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { moneyFormatter } from '../utils'
import { parseUrlPedidosFilter } from './filters/FiltroPedidosQueryParser'
import ListaPedidosFilter from './filters/lista_pedidos.filter.vue'
import AcompanhamentoModal from './modals/AcompanhamentoModal.vue'

const Pedido = namespace('Pedido')

const initialPaginacao = {
  itemsPerPage: 5,
  page: 1,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  mustSort: false,
  multiSort: false
}

@Component({
  name: 'ListaPedidosContainer',
  props: {
    admin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QuestionDialogComponent,
    AcompanhamentoModal,
    MemoryDataTable,
    ListaPedidosFilter
  }
})
export default class ListaPedidosContainer extends Vue {
  @Pedido.Action
  excluirPedido!: (args: { pedidoId: any; hideToast?: boolean }) => Promise<any>

  private paginacao = { ...initialPaginacao }
  private situacaoPedidoMap = situacaoPedidoMap
  private totalItensServer = 0
  private valorTotalPeds = 0
  private isLoading = false

  private get valorTotalPedsFormatted() {
    return moneyFormatter(this.valorTotalPeds)
  }

  tipoPedidoMap = {
    V: 'Venda',
    B: 'Bonificação',
    T: 'Troca',
    A: 'Amostra',
    C: 'Comodato',
    O: 'Consignação',
    N: 'Conta e Ordem',
    M: 'Compra',
    R: 'Carga',
    X: 'Devolução Venda',
    D: 'Devoluções',
    E: 'Entrada',
    S: 'Retorno de vasilhame',
    I: 'Demonstração',
    J: 'Retorno',
    L: 'Remessa de Bem',
    F: 'Outras Entradas',
    Q: 'Outras Saídas',
    P: 'Brinde',
    U: 'Devolução Comodato',
    G: 'Nota Fiscal',
    Z: 'Entrada de Vasilhame',
    K: 'Descarte Entrada',
    W: 'Descarte Saída',
    Y: 'Locação',
    '4': 'Venda Balcão',
    '5': 'Remessa para Consignação',
    '6': 'Venda de Consignação',
    '7': 'Retorno de Consignação',
    '8': 'Comodato Temporário',
    '9': 'Dev Comodato Temporário',
    '1': 'Transferência',
    '3': 'Remessa para Reparo',
    '2': 'Televendas'
  }

  colunasTabela = [
    {
      text: 'Nro. Ped.',
      align: 'start',
      value: 'nroPedido',
      width: '5%',
      visible: true
    },
    {
      text: 'Cliente',
      align: 'start',
      value: 'cliente',
      width: '10%',
      visible: true,
      admin: true
    },
    {
      text: 'Tipo Pedido',
      align: 'start',
      value: 'tipoPedido',
      width: '10%',
      visible: true
    },
    {
      text: 'Forma Pgto.',
      align: 'start',
      value: 'portadorDesc',
      width: '10%',
      visible: true
    },
    {
      text: 'Condição',
      align: 'start',
      value: 'condicaoPagtoDesc',
      width: '5%',
      visible: true
    },
    {
      text: 'Nota Fiscal',
      align: 'start',
      value: 'nroNota',
      width: '5%',
      visible: true
    },
    {
      text: 'Data Criação',
      align: 'start',
      value: 'data',
      width: '5%',
      visible: true
    },
    {
      text: 'Valor Total',
      align: 'start',
      value: 'valorTotal',
      width: '5%',
      sortable: true,
      visible: true
    },
    {
      text: 'Situação',
      align: 'center',
      value: 'situacao',
      width: '5%',
      sortable: true,
      visible: true
    },
    {
      text: 'Comprador',
      align: 'center',
      value: 'comprador',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Ordem Compra',
      align: 'center',
      value: 'ordemCompra',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Data Emissão',
      align: 'center',
      value: 'dataEnvio',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Nro. Série',
      align: 'center',
      value: 'nroSerie',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Data Cancelamento',
      align: 'center',
      value: 'dataCancelamento',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Justificativa Cancelamento',
      align: 'center',
      value: 'obsCancelamento',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Chave de Acesso',
      align: 'center',
      value: 'chaveAcesso',
      width: '5%',
      visible: false
    },
    {
      text: 'Status NFe',
      align: 'center',
      value: 'statusNFE',
      width: '5%',
      sortable: true,
      visible: false
    },
    {
      text: 'Ações',
      align: 'end',
      value: 'acoes',
      width: '1%',
      sortable: false
    }
  ]

  listaPedidos = [] as Array<any>

  get getDtIni() {
    if (this.$props.admin) {
      return new Date(Date.now())
    }

    const dt = new Date(Date.now())
    dt.setUTCMonth(dt.getUTCMonth() - 1)
    return dt
  }

  get currentUser(): any {
    const item = localStorage.getItem('user')
    if (item) return JSON.parse(item)
    else return {}
  }

  @Watch('paginacao')
  onPaginacaoChanged(value: any, oldValue: any) {
    if (!_.isEqual(value, oldValue)) {
      this.$router.push({
        query: { ...this.$router.currentRoute.query, ...value }
      })
    }
  }
  constructor() {
    super()
    this.paginacao =
      parseUrlPedidosFilter(this.$router.currentRoute.query, this.$props.admin)
        .pagination || initialPaginacao
  }

  mounted() {
    this.buscarDadosAPI()
  }

  @Watch('$route.query')
  onQueryChanged() {
    this.buscarDadosAPI()
  }

  async buscarDadosAPI() {
    this.isLoading = true
    const filter = parseUrlPedidosFilter(
      this.$router.currentRoute.query,
      this.$props.admin
    )
    const { pagination, periodo, origem } = filter

    if (!periodo) {
      filter.periodo = {
        dtIni: this.getDtIni,
        dtFim: new Date(Date.now())
      }
    }

    if (!origem) {
      filter.origem = this.$props.admin ? 'PORTAL' : ''
    }

    PedidoService.findAll(
      pagination || initialPaginacao,
      null,
      filter,
      this.$props.admin
    )
      .then((resp: any) => {
        this.totalItensServer = resp.totalItensServer
        this.valorTotalPeds = resp.valorTotal
        this.listaPedidos = resp.listaPedidos
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  // isPedidoViewable(pedido: PedidoInterface) {
  //   console.log(JSON.stringify(pedido));
  //   console.log(JSON.stringify(this.currentUser.id));

  //   return (
  //     pedido.situacao &&
  //     (pedido.situacao != "EDICAO" ||
  //       (pedido.user.id != this.currentUser.id))
  //   );
  // }

  isPedidoEditable(pedido: PedidoInterface) {
    return (
      pedido.situacao &&
      pedido.situacao == 'EDICAO' &&
      pedido.user.id == this.currentUser.id
    )
  }

  onVisualizarPedidoClick(pedido: any) {
    if (pedido.situacao === 'EDICAO') {
      this.$router.push(`/checkout`)
      return
    }

    this.$router.push(`/pedido/${pedido.nroPedido}`)
  }

  onAcompanharPedido(pedido: any) {
    const dlg = this.$refs.acompanhamentoModalRef as any
    dlg.show(pedido?.nroPedido)
  }

  onExcluirPedidoClick(pedido: any) {
    const dlg = this.$refs.removeQuestDlg as QuestionDialogComponent
    dlg.show(pedido.id, {
      title: 'Exclusão de Pedido',
      message: 'Este pedido será excluído permanentemente. Deseja continuar?'
    })
  }

  handleCancelamentoPedido(payload: any) {
    const pedido = this.listaPedidos.find(el => el.id === payload)
    pedido.isLoadingD = true
    this.excluirPedido({ pedidoId: payload }).then(
      () => {
        pedido.isLoadingD = undefined
        this.buscarDadosAPI()
      },
      () => {
        pedido.isLoadingD = undefined
      }
    )
  }

  formatValor(valor: any) {
    return moneyFormatter(valor)
  }
  formatData(valor: any) {
    if (!valor) return '-'
    const dateVal = new Date(valor).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    })
    return dateVal
  }

  async openDanfe(pedido: any) {
    const dialog = this.$refs.downloadPdfDialog as any
    dialog.show(pedido, {
      title: 'Download DANFE',
      message: 'Deseja baixar o DANFE deste pedido?'
    })
  }

  async downloadPdf(pedido: any) {
    await PedidoService.getNfePdf({ chaveAcesso: pedido.chaveAcesso, nroPedido: pedido.nroPedido })
      .then((pdf: any) => {
        const url = window.URL.createObjectURL(pdf)
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.setAttribute('download', pedido.chaveAcesso + '.pdf')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
      .catch((error: any) => {
        this.$store.dispatch(
          'Notifications/showErrorMessage',
          'Não foi possível baixar o DANFE, tente novamente mais tarde.'
        )
        throw error
      })
  }

  async downloadNfeXml(pedido: any) {
    const chaveAcesso = pedido?.chaveAcesso
    const xml = await PedidoService.getNfeXml({ chaveAcesso }).catch(
      (error: any) => {
        this.$store.dispatch(
          'Notifications/showErrorMessage',
          'Não foi possível baixar o XML, tente novamente mais tarde.'
        )
        throw error
      }
    )

    const url = window.URL.createObjectURL(new Blob([xml]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', chaveAcesso + '.xml')
    document.body.appendChild(link)
    link.click()
  }

  async downloadFatura(pedido: any) {
    const nroVenda = pedido?.nroVenda
    const pdf = await PedidoService.getFaturaPdf({ nroVenda }).catch(
      (error: any) => {
        this.$store.dispatch(
          'Notifications/showErrorMessage',
          'Não foi possível baixar a fatura, tente novamente mais tarde.'
        )
        throw error
      }
    )

    const url = window.URL.createObjectURL(new Blob([pdf]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', nroVenda + '.pdf')
    document.body.appendChild(link)
    link.click()
  }
}
